(() => {
  'use strict';
  if (window.ddPajamaStockBound) return;
  window.ddPajamaStockBound = true;
  function bind(root) {
    if (root.dataset.ddPjStockBound) return;
    const config = root.querySelector('[data-dd-pj-stock-variants]');
    if (!config) return;
    const variants = JSON.parse(config.textContent);
    root.dataset.ddPjStockBound = 'true';
    function apply(variant) {
      root.dataset.ddPjStock = variant ? (variant.available ? 'available' : 'sold-out') : 'unavailable';
    }
    function selected() {
      const picker = root.querySelector('variant-radios,variant-selects');
      if (!picker) return;
      const values = picker.tagName.toLowerCase() === 'variant-radios'
        ? [...picker.querySelectorAll('input[type="radio"]:checked')].map(input => input.value)
        : [...picker.querySelectorAll('select')].map(input => input.value);
      if (!values.length) return;
      apply(variants.find(variant => variant.options.length === values.length && variant.options.every((option,index) => option === values[index])));
    }
    root.addEventListener('change', event => {
      if (event.target.closest('variant-radios,variant-selects')) selected();
    });
    selected();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (!root.isConnected) { unsubscribe(); return; }
        if (String(event.data.sectionId) === root.dataset.section) apply(event.data.variant);
      });
    }
  }
  function scan() { document.querySelectorAll('product-info[data-dd-pj-stock]').forEach(bind); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
